/** Tenant identifier shared between Project Web, Planner Web & Planner Mobile representing all environments */ export const LogTenantIdentifier = "24c1b08831774b999295fd9fd5944757-cfc7f993-81c6-40ec-85f2-94190aa6498f-6796";
